import { OrganizationService } from '../services/OrganizationService';

// eslint-disable-next-line import/prefer-default-export
export const getOrganizationList = async () => {
	const { status, data } =
		await OrganizationService.getOrganizationListService();
	if (status === 200) {
		return data;
	}
	return false;
};
